import { VA_EVENTS } from '@/lib/analytics/event-catalog';
import { gtmEvent, metaTrack } from '@/lib/analytics/marketing-events';
import { vaTrack } from '@/lib/analytics/vercel-events';

export type ContactLinkKind = 'phone' | 'email' | 'directions';

function isDirectionsUrl(href: string): boolean {
  const h = href.trim().toLowerCase();
  if (h.startsWith('tel:') || h.startsWith('mailto:')) return false;
  try {
    const u = new URL(href, 'https://example.com');
    const host = u.hostname.toLowerCase();
    if (host === 'maps.app.goo.gl' || host.endsWith('.goo.gl')) return true;
    if (host === 'maps.google.com' || host.endsWith('.google.com')) {
      if (u.pathname.includes('/maps')) return true;
    }
    return false;
  } catch {
    return false;
  }
}

export function classifyContactHref(href: string): ContactLinkKind | null {
  const t = href.trim();
  if (!t) return null;
  if (t.toLowerCase().startsWith('tel:')) return 'phone';
  if (t.toLowerCase().startsWith('mailto:')) return 'email';
  if (isDirectionsUrl(t)) return 'directions';
  return null;
}

/** GTM/Meta when consent + tags enabled; Vercel always. */
export function trackContactLinkClick(href: string, location?: string): void {
  const kind = classifyContactHref(href);
  if (!kind) return;

  const locationData = location ? { location } : undefined;

  switch (kind) {
    case 'phone':
      gtmEvent({ event: 'contact_phone' });
      metaTrack('Contact');
      vaTrack(VA_EVENTS.CONTACT_PHONE, locationData);
      break;
    case 'email':
      gtmEvent({ event: 'contact_email' });
      metaTrack('Contact');
      vaTrack(VA_EVENTS.CONTACT_EMAIL, locationData);
      break;
    case 'directions':
      gtmEvent({ event: 'contact_directions' });
      metaTrack('FindLocation');
      vaTrack(VA_EVENTS.CONTACT_DIRECTIONS, locationData);
      break;
    default:
  }
}
